import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
  },

  saveButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'white',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '39%',
    marginRight: '3%',
    backgroundColor: '#DF0C36',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 5px white',
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#DF0C36',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '36%',
    marginRight: '3%',
    boxShadow: '0px 15px 20px rgb(217 224 221 / 40%)',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  collapseButton: {
    fontFamily: 'HelveticaNeueLTStd-Cn',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '20px',
    color: '#DF0C36',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  expandButton: {
    fontFamily: 'HelveticaNeueLTStd-Cn',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '18px',
    marginTop: '20px',
    color: '#666666',
    textTransform: 'capitalize',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#DF0C36',
    marginBottom: 7,
  },
}));
